const getVariantIndexFromKey = (source) => {
  if (!source) {
    return null;
  }
  const match = source.match(/legal-content-variant(\d+)/);
  return match ? Number(match[1]) : null;
};

const adjustEmptyVariantValidation = (schema, data) => {
  if (!schema || !schema.length) {
    return schema;
  }

  return schema.map((section) => {
    if (section.id !== "codes-legal") {
      return section;
    }

    const groups = section.groups || section.children || [];

    const variantGroups = groups.filter((group) => {
      const idx = getVariantIndexFromKey(group.id);
      return idx !== null;
    });

    if (variantGroups.length === 0) {
      return section;
    }

    const lastVariantGroup = variantGroups[variantGroups.length - 1];
    const lastVariantIdx = getVariantIndexFromKey(lastVariantGroup.id);

    if (lastVariantIdx === null) {
      return section;
    }

    const otherFields = [
      `codes-legal/legal-content-variant${lastVariantIdx}/variant-provider-service`,
      `codes-legal/legal-content-variant${lastVariantIdx}/variant-complaints-policy`,
      `codes-legal/legal-content-variant${lastVariantIdx}/variant-withdrawal-policy`,
    ];

    const hasAnyOtherFieldValue = otherFields.some(
      (key) => data[key] && String(data[key]).trim()
    );

    if (!hasAnyOtherFieldValue) {
      const updatedGroups = groups.map((group) => {
        if (group.id === lastVariantGroup.id) {
          const fieldsSource = group.fields || group.children || [];

          const updatedFields = fieldsSource.map((field) => {
            if (field.id === "variant-name" && field.validation) {
              return {
                ...field,
                validation: field.validation.filter((v) => v !== "required"),
              };
            }
            return field;
          });

          const updatedGroup = { ...group };
          if (group.fields) {
            updatedGroup.fields = updatedFields;
          }
          if (group.children) {
            updatedGroup.children = updatedFields;
          }

          return updatedGroup;
        }
        return group;
      });

      const updatedSection = { ...section };
      if (section.groups) {
        updatedSection.groups = updatedGroups;
      }
      if (section.children) {
        updatedSection.children = updatedGroups;
      }

      return updatedSection;
    }

    return section;
  });
};

export default adjustEmptyVariantValidation;
